import React from 'react';
import Title from '../components/common/Title';

const AboutPage: React.FC = () => {
  return (
    <>
      <Title title="About Us" />
      <main>
        <div className="container">
          <div style={{ marginTop: '120px', marginBottom: '50px' }}>
            <h1 className="section-title">About Quick Flick</h1>
            
            <div style={{ marginTop: '30px', lineHeight: '1.6' }}>
              <p style={{ marginBottom: '20px' }}>
                Quick Flick is a premier streaming service that brings you the best movies and TV shows from around the world. 
                Founded in 2020, we've quickly grown to become a favorite destination for entertainment enthusiasts.
              </p>
              
              <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>Our Mission</h2>
              <p style={{ marginBottom: '20px' }}>
                At Quick Flick, our mission is to provide an exceptional streaming experience that makes discovering and enjoying 
                great content effortless and affordable. We believe in the power of storytelling to inspire, educate, and unite 
                people across cultures and backgrounds.
              </p>
              
              <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>What Sets Us Apart</h2>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '30px' }}>
                <div style={{ 
                  flex: '1 1 300px',
                  background: 'var(--secondary-color)',
                  padding: '20px',
                  borderRadius: '8px'
                }}>
                  <h3 style={{ color: 'var(--primary-color)', marginBottom: '10px' }}>Curated Content</h3>
                  <p>
                    We carefully select and curate our library to include award-winning films, binge-worthy series, and hidden gems 
                    you won't find elsewhere.
                  </p>
                </div>
                
                <div style={{ 
                  flex: '1 1 300px',
                  background: 'var(--secondary-color)',
                  padding: '20px',
                  borderRadius: '8px'
                }}>
                  <h3 style={{ color: 'var(--primary-color)', marginBottom: '10px' }}>User Experience</h3>
                  <p>
                    Our platform is designed with users in mind, offering intuitive navigation, personalized recommendations, 
                    and seamless playback across all your devices.
                  </p>
                </div>
                
                <div style={{ 
                  flex: '1 1 300px',
                  background: 'var(--secondary-color)',
                  padding: '20px',
                  borderRadius: '8px'
                }}>
                  <h3 style={{ color: 'var(--primary-color)', marginBottom: '10px' }}>Innovation</h3>
                  <p>
                    We're constantly improving our technology to deliver the highest quality streaming experience, 
                    with support for 4K, HDR, and advanced audio formats.
                  </p>
                </div>
              </div>
              
              <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>Our Story</h2>
              <p style={{ marginBottom: '20px' }}>
                Quick Flick began with a simple idea: to create a streaming platform that truly understands what viewers want. 
                Our founders, a team of technology enthusiasts and film lovers, set out to build a service that combines cutting-edge 
                technology with thoughtful content curation.
              </p>
              <p style={{ marginBottom: '20px' }}>
                Since our launch, we've expanded our library to include thousands of titles across every genre imaginable. 
                We've partnered with major studios and independent filmmakers alike to bring diverse and compelling stories to our audience.
              </p>
              <p style={{ marginBottom: '20px' }}>
                Today, Quick Flick is available in over 30 countries, with plans to continue our global expansion. We're proud of how 
                far we've come, but we're even more excited about the journey ahead.
              </p>
              
              <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>Join Our Team</h2>
              <p style={{ marginBottom: '20px' }}>
                We're always looking for talented individuals who are passionate about entertainment and technology to join our growing team. 
                Visit our <a href="/careers" style={{ color: 'var(--primary-color)' }}>Careers</a> page to learn more about current opportunities.
              </p>
              
              <div style={{ 
                background: 'var(--secondary-color)',
                padding: '30px',
                borderRadius: '8px',
                textAlign: 'center',
                marginTop: '40px'
              }}>
                <h2 style={{ marginBottom: '15px' }}>Get in Touch</h2>
                <p style={{ marginBottom: '20px' }}>
                  Have questions or feedback? We'd love to hear from you!
                </p>
                <a href="/contact" className="btn btn-primary">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AboutPage; 